module.exports = __webpack_public_path__ + "static/assets/8b58634e8fdb5b24fc21d66bd0bc3ae0.png";